import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=6dff7a32&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=ts"
export * from "./Credits.vue?vue&type=script&lang=ts"
import style0 from "./Credits.scss?vue&type=style&index=0&id=6dff7a32&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff7a32",
  null
  
)

export default component.exports